<template>
  <div class="tabs-slider">
    <button ref="prev" class="tabs-slider__nav _prev">
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9675 10.0001L6.66406 15.3035L8.17902 16.8185L14.9974 10.0001L8.17902 3.18173L6.66406 4.69668L11.9675 10.0001Z"></path>
      </svg>
    </button>

    <swiper
        v-if="showSlider"
        ref="slider"
        class="tabs-slider__swiper"
        v-bind="swiperOpts"
        @afterInit="afterInitSlider"
        @swiper="onSwiper"
        :navigation="{
              prevEl: prev,
              nextEl: next,
            }"
    >
      <template v-slot:wrapper-start><div ref="tabs-slider-bg" class="tabs-slider__bg"></div></template>

      <swiper-slide v-for="(tab, index) in slides" :key="`handler-${index}`" class="swiper-slide tabs-slider__slide" :class="{ _active: currentIndexSlide === index}" @click="switchSlide(tab, index, $event)">
        <div class="tabs-slider__item" :class="{ _active: currentIndexSlide === index}">{{ tab.label }}</div>
      </swiper-slide>

    </swiper>
    <button ref="next" class="tabs-slider__nav _next">
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.9675 10.0001L6.66406 15.3035L8.17902 16.8185L14.9974 10.0001L8.17902 3.18173L6.66406 4.69668L11.9675 10.0001Z"></path>
      </svg>
    </button>
  </div>
</template>

<script>

import { Swiper, SwiperSlide,   } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper';
import {ref} from "vue";

export default {
  name: "DTabsSlider",
  components: {SwiperSlide, Swiper},
  setup() {
    const prev = ref(null);
    const next = ref(null);
    const pagination = ref(null)
    return {
      modules: [Navigation, Pagination],
      prev,
      next,
      pagination
    };
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    initSlide: {
      type: Number,
      default: 0
    },
    isFurnish: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: null,
      currentIndexSlide: 0,
      swiperOpts: {
        slidesPerView: 'auto',
        freeMode: {
          enabled: true,
        },
        resistance: true,
        enabled: false,
        breakpoints: {
          // 1280: {
          //   enabled: true,
          // }
        },
        resistanceRatio: 0,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
      },
      showSlider: true
    }
  },
  created() {
    this.currentIndexSlide = this.initSlide
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      // this.onResize();
    })
  },
  unmounted() {
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    initSlide(val) {
      this.currentIndexSlide = val
    }
  },
  methods: {
    afterInitSlider(swiper) {
      swiper.enable()
      if (this.isFurnish && !swiper.destroyed) {
        this.updateSizeSlides(swiper)
      }

      setTimeout(() => {
        this.updateSliderBg(swiper)
      }, 100)
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    switchSlide(tab, index, e) {
      const $bg = this.$refs["tabs-slider-bg"]

      this.currentIndexSlide = index
      this.swiper.slideTo(index);

      const width = this.swiper.slidesSizesGrid[index];
      const left = e.target.parentNode.offsetLeft

      $bg.style.width = `${width}px`
      $bg.style.left = `${left}px`

      this.$emit('changeSlide', {tab, index})

    },
    updateSizeSlides(swiper) {
      if (swiper.isLocked && swiper.slides) {
        const slides = Array.from(swiper.slides)
        const remainderOfContainer = swiper.slidesSizesGrid.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0,
        );

        const wrapperWidth = swiper.wrapperEl.getBoundingClientRect().width
        const plusWidth = (wrapperWidth - remainderOfContainer) / this.slides.length

        slides.forEach(slide => {
          slide.style.width = `${slide.offsetWidth + plusWidth}px`
        })
      }
    },
    updateSliderBg(swiper) {
      if (swiper.slides) {
        const slides = Array.from(swiper.slides)
        const currentTabEl = slides.find(item => item.classList.contains("_active"))
        const currentTabindex = slides.findIndex(item => item.classList.contains("_active"))
        const $bg = this.$refs["tabs-slider-bg"]
        const translateSwiper = Math.abs(swiper.translate);

        const width = swiper.slidesSizesGrid[currentTabindex];
        const left = currentTabEl.offsetLeft

        $bg.style.width = `${width}px`
        $bg.style.left = `${ translateSwiper ? left : left}px`
      }

    },
    onResize() {
      this.showSlider = false
      setTimeout(() => {
        this.showSlider = true
      }, 50)
    },
  }
}
</script>


<style scoped>

</style>